import React from 'react';
import DashboardHome from '../components/DashboardHome';

const OwnerDashboard = () => {
  // This is now just the Dashboard HOME view for the Buyer
  // The Layout is handled by BuyerLayout wrapper in routes/index.js if we switch it completely
  // BUT, in my current plan, I left OwnerDashboard as a monolithic page.
  // However, to fix the issue where sidebar is missing on /messages, I introduced BuyerLayout.
  // If I want CONSISTENCY, I should probably make OwnerDashboard JUST render the DashboardHome content
  // and rely on the URL routing.

  // For now, to minimize breakage of existing dashboard functionality, let's keep this as content only
  // assuming it will be rendered INSIDE BuyerLayout via <Outlet> if I change the route.

  // WAIT: In routes/index.js: <Route path="/owner-dashboard" element={<ProtectedRoute><OwnerDashboard /></ProtectedRoute>} />
  // It is NOT wrapped in RoleBasedLayout/BuyerLayout there yet.

  return <DashboardHome />;
};

export default OwnerDashboard;
